import { FEEDBACK_ACTION } from "../const";

export const getFeedback = (payload: any) => {
    return {
        type: FEEDBACK_ACTION,
        payload: payload,
    };
};
